var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicleTypeTruck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23.37 24.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{clip-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{isolation:isolate;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{clip-path:url(#clip-path-3);}.cls-7{fill:#101620;opacity:0.9;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.19,9.35h-7a.4.4,0,0,0-.39.32V14h7.79V9.74A.39.39,0,0,0,15.19,9.35Zm2.72-5.46a1.57,1.57,0,0,1,1.56,1.45v11H17.91V5.84a.37.37,0,0,0-.3-.38H5.86a.42.42,0,0,0-.4.32V16.36H3.89V5.45A1.56,1.56,0,0,1,5.34,3.9H17.91ZM10.12,15.58H7.79v1.55h2.33Zm5.46,0H13.24v1.55h2.34Zm.78-7.79a.79.79,0,0,1,.77.69V18.69a1.56,1.56,0,0,1-1.44,1.56H14V18.69H9.35v1.56H7.79a1.57,1.57,0,0,1-1.56-1.44V8.57a.79.79,0,0,1,.69-.78h9.44Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 23.37,
    height: 24.14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.89,
    y: 3.89,
    width: 15.58,
    height: 16.36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 23.37,
    height: 24.14
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleTypeTruck);
export default __webpack_public_path__ + "static/media/vehicle-type-truck.3cf97c216301c27357042c16ff13eb04.svg";
export { ForwardRef as ReactComponent };